import { restGet } from "apiCommandsExecutor/rest";

import { TariffDto } from "./restModels";

// ===== Каталог тарифов (REST /api/rest/warehouse/v1) =====

export const getTariffs = () => restGet<TariffDto[]>("/tariffs");
